import { Suspense } from 'components/common/Suspense/index.js';
import {
  AccountPage,
  AccountsPage,
  ColleaguesPage,
  ColleagueViewPage,
  CompanyPage,
} from 'features/organization/index.js';
import {
  HoldingsPage,
  UnitPage,
} from 'features/units/index.js';
import {
  Navigate,
  Route,
} from 'react-router';
import { RoutePaths } from 'shared/routes.js';
import { asLazy } from 'shared/utils/lazy.utils.js';

import { useNavigationMenu } from '../utils/navigationMenu.js';
import { useRoutesRootElement } from './useRoutesRootElement.js';

const LogsPage = asLazy(import('../../pages/logs/LogsPage.js'), 'LogsPage');

const ProfileSettingsPage = asLazy(
  import('../../pages/profile-settings/ProfileSettingsPage.js'),
  'ProfileSettingsPage',
);

export const useRegularRoutes = () => {
  const navigationItems = useNavigationMenu();
  const renderRootElement = useRoutesRootElement();

  return (
    <Route path="/" element={renderRootElement(navigationItems)}>
      <Route
        path={RoutePaths.COMPANY}
        element={(
          <Suspense>
            <CompanyPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.ACCOUNTS}
        element={(
          <Suspense>
            <AccountsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.COLLEAGUES}
        element={(
          <Suspense>
            <ColleaguesPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.COLLEAGUE()}
        element={(
          <Suspense>
            <ColleagueViewPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.PROFILE_SETTINGS}
        element={(
          <Suspense>
            <ProfileSettingsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.ACCOUNT()}
        element={(
          <Suspense>
            <AccountPage />
          </Suspense>
        )}
      />
      <Route path={RoutePaths.USERS} element={null} />
      <Route path={RoutePaths.COLLEAGUES} element={null} />
      <Route
        path={RoutePaths.HOLDINGS}
        element={(
          <Suspense>
            <HoldingsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.LOGS}
        element={(
          <Suspense>
            <LogsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.UNIT_VIEW()}
        element={(
          <Suspense>
            <UnitPage />
          </Suspense>
        )}
      />
      <Route path="/" element={<Navigate to={RoutePaths.COMPANY} />} />
    </Route>
  );
};
